import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchJourneyTireOffers(params) {
  try {
    const tireOffers = yield call(function() {
      return Api.get(`/journey/tireOffers/${params.uuid}`)
    });
    yield put({type: 'FETCH.JOURNEY_TIRE_OFFERS.SUCCESS', tireOffers});
  } catch (error) {
    yield put({type: 'FETCH.JOURNEY_TIRE_OFFERS.FAILURE', error});
  }
}

function* saveJourneyTireOffers(params) {
  try {
    const tireOffers = yield call(function() {
      return Api.post(`/journey/tireOffers/${params.id}`, params.body)
    });
    yield put({type: 'SAVE.JOURNEY_TIRE_OFFERS.SUCCESS', tireOffers});
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id:params.interventionId});

  } catch (error) {
    yield put({type: 'SAVE.JOURNEY_TIRE_OFFERS.FAILURE', error});
  }
}

function* deleteJourneyTireOffers(params) {
  try {
    const tireOffers = yield call(function() {
      return Api.delete(`/journey/tireOffers/${params.uuid}?key=${params.key}`)
    });
    yield put({type: 'DELETE.JOURNEY_TIRE_OFFERS.SUCCESS', tireOffers});
    yield put({type: 'FETCH.INTERVENTION.REQUEST', id:params.interventionId});
  } catch (error) {
    yield put({type: 'DELETE.JOURNEY_TIRE_OFFERS.FAILURE', error});
  }
}

export function* watchFetchJourneyTireOffers() {
  yield takeEvery('FETCH.JOURNEY_TIRE_OFFERS.REQUEST', fetchJourneyTireOffers)
}

export function* watchSaveJourneyTireOffers() {
  yield takeEvery('SAVE.JOURNEY_TIRE_OFFERS.REQUEST', saveJourneyTireOffers)
}

export function* watchDeleteJourneyTireOffers() {
  yield takeEvery('DELETE.JOURNEY_TIRE_OFFERS.REQUEST', deleteJourneyTireOffers)
}
